module.exports = __webpack_public_path__ + "img/at (7).90b86e40.jpg";